import factory from '../../../store/factory'

export default {
  file_transfer: factory('FileTransfer')
}